import * as React from 'react';
import { OffboardingPage } from './OffboardingPage';

const AzureOffboarding: React.FunctionComponent = () => (
  <OffboardingPage taskDefId="azure-app" heading="Azure" />
);

export { AzureOffboarding };
